import dayjs from 'dayjs';

export default function (dateObj, pattern) {
    if (Object.prototype.toString.call(dateObj) !== '[object Date]') {
        console.log('第一个参数需要传入Date类型');
        return;
    }

    let year = dateObj.getFullYear();
    let month = (dateObj.getMonth() + 1).toString().replace(/^(\d)$/, '0$1');
    let date = dateObj
        .getDate()
        .toString()
        .replace(/^(\d)$/, '0$1');

    return pattern
        .replace('yyyy', year)
        .replace('mm', month)
        .replace('dd', date);
}

/**
 * 秒数转换为时间格式
 * @param {*} time 秒数
 * @param {*} formatter 格式化 如hh:mm:ss
 * @returns {string} 格式化后的时间
 */
export function timeFormat(time, formatter) {
    if (time <= 0) {
        return formatter
            ? formatter
                .replace('hh', '00')
                .replace('mm', '00')
                .replace('ss', '00')
            : '0小时0分0秒';
    }

    let hour = Math.floor(time / 3600)
        .toString()
        .replace(/^(\d)$/, '0$1');
    let minute = Math.floor((time - hour * 3600) / 60)
        .toString()
        .replace(/^(\d)$/, '0$1');
    let second = Math.floor(time - hour * 3600 - minute * 60)
        .toString()
        .replace(/^(\d)$/, '0$1');

    if (formatter) {
        return formatter
            .replace('hh', hour)
            .replace('mm', minute)
            .replace('ss', second);
    }
    return `${hour}小时${minute}分${second}秒`;
}

/**
 * @method 将时间戳转化成相应的数据
 * @param {*} item 时间戳
 * @param {*} type 代表10为还是13位时间戳  1是10位  2是13位
 * @return {string} 返回格式化时间
 */
export const formateDate = (item, type = 1) => {
    let dayObj;
    if (+type === 1) {
        dayObj = dayjs.unix(item);
    }
    else if (+type === 2) {
        dayObj = dayjs(item);
    }
    else {
        console.log('第一个参数需要传入时间戳');
        return;
    }

    const year = dayObj.year();
    const month = dayObj.month() + 1;
    const day = dayObj.date();
    let hour = dayObj.hour();
    hour = hour < 10 ? (`0${hour}`) : hour;
    let minute = dayObj.minute();
    minute = minute < 10 ? (`0${minute}`) : minute;
    let second = dayObj.second();
    second = second < 10 ? (`0${second}`) : second;

    return {
        year,
        month,
        day,
        hour,
        minute,
        second
    };
};

/**
 * @method 十位时间戳 转换为 yyyy-mm-dd hh:mm:ss 格式
 * @param {number}
 * @param {*} type 代表10为还是13位时间戳  1是10位  2是13位
 * @param {*} format
 * 1: 转换为 yyyy.mm.dd hh:mm:ss 格式
 * 2: 转换为 yyyy-mm-dd hh:mm:ss 格式
 * @returns string
 */
export const timestampToTime = (timestamp, type = 1, format = 1) => {
    const date = formateDate(timestamp, type);
    const {year, month, day, hour, minute, second} = date;
    if (+format === 1) {
        return `${year}.${month}.${day} ${hour}:${minute}:${second}`;
    }
    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
};

/**
 * 日期格式化
 * @function dateFormat
 * @param {Date} d - date 对象
 * @param {string} [pattern = 'yyyy-MM-dd'] - 字符串
 * @return {string} 处理后的字符串
 * @example
 *var d = new Date();
 *  dateFormat(d," yyyy年M月d日\n yyyy-MM-dd\n MM-dd-yy\n yyyy-MM-dd hh:mm:ss")
 *  //2018年11月10日\n 2018-01-01\n 01-01-18\n 2018-11-12 12:01:02
 */
/* eslint-disable */
export const formatDate = (d, pattern = 'yyyy-MM-dd') => {
    let y = d.getFullYear().toString();
    let o = {
        M: d.getMonth() + 1, // month
        d: d.getDate(), // day
        h: d.getHours(), // hour
        m: d.getMinutes(), // minute
        s: d.getSeconds(), // second
    };
    pattern = pattern.replace(/(y+)/gi, (a, b) => y.substr(4 - Math.min(4, b.length)));
    Object.keys(o).forEach(i => {
        pattern = pattern.replace(new RegExp('(' + i + '+)', 'g'), (a, b) =>
            o[i] < 10 && b.length > 1 ? '0' + o[i] : o[i]
        );
    });
    return pattern;
};
/* eslint-enable */

export const formatSeconds = (seconds) => {
    // 取整数部分
    seconds = Math.floor(seconds);

    // 计算分钟和剩余的秒数
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;

    // 格式化分钟和秒数，如果小于10则在前面加0
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = remainingSeconds < 10 ? '0' + remainingSeconds : remainingSeconds;

    // 返回格式化后的字符串
    return `${formattedMinutes}:${formattedSeconds}`;
};